"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useReadOnly = void 0;
var _react = require("react");
const emptyArray = [];
const useReadOnly = function () {
  let readOnlyGroups = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : emptyArray;
  let readOnlyStudents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : emptyArray;
  //todo:  Fix with TaskManager
  const [readOnlyGroupsMapper, setReadOnlyGroupsMapper] = (0, _react.useState)([]);
  const [readOnlyStudentsMapper, setReadOnlyStudentsMapper] = (0, _react.useState)([]);
  (0, _react.useEffect)(() => {
    let mapper = {};
    if (readOnlyGroups) {
      readOnlyGroups.forEach(group => mapper[group.id] = group);
    }
    setReadOnlyGroupsMapper(mapper);
  }, [readOnlyGroups]);
  (0, _react.useEffect)(() => {
    let mapper = {};
    if (readOnlyStudents) {
      readOnlyStudents.forEach(student => mapper[student.id || student.studentID] = student);
    }
    setReadOnlyStudentsMapper(mapper);
  }, [readOnlyStudents]);
  return {
    readOnlyGroupsMapper,
    readOnlyStudentsMapper
  };
};
exports.useReadOnly = useReadOnly;